import { useEffect, useState } from 'react';
import { api } from '../../api/client';
import type { Meta } from '../../types';

// Petit cache module-level : /api/meta (libellés statuts + pôles) ne change
// quasi jamais pendant une session — évite de le refetch sur chaque page.
let cache: Meta | null = null;
let enCours: Promise<Meta> | null = null;

export function useMeta() {
  const [meta, setMeta] = useState<Meta | null>(cache);
  const [loading, setLoading] = useState(!cache);
  const [erreur, setErreur] = useState<string | null>(null);

  useEffect(() => {
    if (cache) { setMeta(cache); setLoading(false); return; }
    let annule = false;
    setLoading(true);
    (enCours ?? (enCours = api.getMeta()))
      .then((m) => { cache = m; if (!annule) { setMeta(m); setLoading(false); } })
      .catch((err: unknown) => {
        enCours = null;
        if (!annule) { setErreur(err instanceof Error ? err.message : 'Impossible de charger les réglages.'); setLoading(false); }
      });
    return () => { annule = true; };
  }, []);

  return { meta, loading, erreur };
}
